(function () {
  'use strict';

  const APP_PROXY_PATH = '/apps/crear-caso';
  const FORM_SELECTOR  = '#ContactForm, form[action="/contact"], form[action^="/contact"]';
  const IDEMP_KEY_STORE = 'crearCaso:activeKey';
  const IDEMP_KEY_AT    = 'crearCaso:activeKeyAt';
  const IDEMP_TTL_MS    = 60 * 1000; // 60s

  console.log('[CrearCaso] one-shot + idempotencia (sin pixel fallback)');

  // --- Utils ---
  const now = () => Date.now();

  function getActiveKey() {
    try {
      const key = sessionStorage.getItem(IDEMP_KEY_STORE);
      const at  = Number(sessionStorage.getItem(IDEMP_KEY_AT) || '0');
      if (key && (now() - at) < IDEMP_TTL_MS) return key;
    } catch {}
    return null;
  }

  function setActiveKey(key) {
    try {
      sessionStorage.setItem(IDEMP_KEY_STORE, key);
      sessionStorage.setItem(IDEMP_KEY_AT, String(now()));
    } catch {}
  }

  function clearActiveKey() {
    try {
      sessionStorage.removeItem(IDEMP_KEY_STORE);
      sessionStorage.removeItem(IDEMP_KEY_AT);
    } catch {}
  }

  function uuid() {
    // RFC4122 v4 compatible
    return (crypto?.randomUUID?.() ||
      ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
        (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
      ));
  }

  function collectFormData(form) {
    // Si tienes checkboxes con mismo name, avísame y te doy una versión que acumula arrays.
    const fd = new FormData(form);
    return Object.fromEntries(fd.entries());
  }

  async function sendOnce(data, idempKey) {
    const url     = `${APP_PROXY_PATH}?t=${Date.now()}`;
    const payload = JSON.stringify(data);

    // Intento #1: sendBeacon
    if (navigator.sendBeacon) {
      try {
        const blob = new Blob([payload], { type: 'application/json' });
        const ok = navigator.sendBeacon(url, blob);
        if (ok) {
          console.log('[CrearCaso] beacon encolado ✅');
          return 'beacon';
        }
        console.warn('[CrearCaso] beacon no se encoló → fallback fetch');
      } catch (e) {
        console.warn('[CrearCaso] beacon error → fallback fetch', e);
      }
    }

    // Intento #2: fetch keepalive (único)
    try {
      await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
          'X-Idempotency-Key': idempKey
        },
        body: payload,
        keepalive: true,
        credentials: 'same-origin',
        cache: 'no-store'
      });
      console.log('[CrearCaso] fetch keepalive enviado ✅');
      return 'fetch';
    } catch (e) {
      console.error('[CrearCaso] fetch keepalive falló', e);
      return 'error';
    }
  }

  function findForm() {
    // Toma SOLAMENTE el primero que cumpla el selector
    return document.querySelector(FORM_SELECTOR);
  }

  function wire(form) {
    if (!form || form.dataset.crearCasoWired === '1') return;
    form.dataset.crearCasoWired = '1';

    if (!/^post$/i.test(form.getAttribute('method') || '')) {
      form.setAttribute('method', 'post');
    }

    // “Candado” global por si el theme re‑inyecta el form (evita múltiples envíos de este script)
    if (window.__crearCasoLock) return;
    window.__crearCasoLock = true;

    form.addEventListener('submit', async (e) => {
      try {
        // No prevenimos el submit nativo (para no romper reCAPTCHA)
        // Pedimos token reCAPTCHA (no bloquea)
        try {
          if (window.Shopify?.recaptchaV3?.addToken) {
            window.Shopify.recaptchaV3.addToken(form);
          }
        } catch (err) {
          console.warn('[CrearCaso] addToken warning:', err);
        }

        // Idempotency-Key estable durante 60s (reutilizada incluso si el form se re‑inyecta)
        let idempKey = getActiveKey();
        if (!idempKey) {
          idempKey = uuid();
          setActiveKey(idempKey);
        }

        // Construye payload
        const data = collectFormData(form);
        data._path              = location.pathname + location.search;
        data._ts                = Date.now();
        data._idempotency_key   = idempKey;

        // (Opcional) token propio para tu backend
        // Si no usas token, comenta el bloque siguiente
        // try {
        //   const token = await fetch(`${APP_PROXY_PATH}/token?t=${Date.now()}`, { credentials: 'same-origin' })
        //     .then(r => r.ok ? r.json() : null)
        //     .catch(() => null);
        //   if (token?.token) data.n8n_token = token.token;
        // } catch {}

        // Disparo único (beacon O fetch)
        sendOnce(data, idempKey).then(() => {
          // Limpia la llave un poco después (no inmediato para cubrir redirección)
          setTimeout(clearActiveKey, 10 * 1000);
        });

      } catch (err) {
        console.error('[CrearCaso] submit handler error:', err);
      }
    }, { once: true }); // ← MUY IMPORTANTE: se ejecuta solo 1 vez por elemento
  }

  function init() {
    const form = findForm();
    if (form) wire(form);
    const mo = new MutationObserver(() => {
      const f = findForm();
      if (f) wire(f);
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
